import { Container, Row, Col, Card, CardHeader, CardBody } from "reactstrap";
import SimpleHeader from "../../components/SimpleHeader/SimpleHeader";

const NotAuthorized = () => {
  return (
    <div id="not-authorized">
      <SimpleHeader name="Not Authorized" parentName="Home" />
      <Container className="mt--6 fluid">
        <Row className="justify-content-center">
          <Col className="card-wrapper">
            <Card>
              <CardHeader>
                <h2 className="m-4">
                  Not Authorized{" "}
                  <i className="ni ni-fat-remove text-red ni-2x align-bottom"></i>
                </h2>
              </CardHeader>
              <CardBody>
                <p>Sorry, looks like you're not setup to manage an Account!</p>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default NotAuthorized;
